import { useIntl, useLogout, WEB_RECOVERY_TIME_BETWEEN_MODALS } from '@capsicum/common';
import { useInfoModal } from '@capsicum/common-web';

export const useForcedRequirementsDismiss = () => {
	const { $t } = useIntl();
	const logout = useLogout();

	const { showInfoModal } = useInfoModal();

	const onDismiss = (callback?: () => void) => {
		showInfoModal({
			buttonOnHandlers: {
				onPrimaryButtonHandler: () => {
					callback && setTimeout(callback, WEB_RECOVERY_TIME_BETWEEN_MODALS);
				},
				onSecondaryButtonHandler: logout
			},
			buttonTexts: {
				primaryButtonText: $t('global.button.continue'),
				secondaryButtonText: $t('global.button.logout')
			},
			image: 'warning',
			isClosable: false,
			subtitle: $t('jurisdictionRequirements.forcedDismissModal.message'),
			testID: 'forced-requirements-dismiss',
			title: $t('jurisdictionRequirements.forcedDismissModal.title'),
			variant: 'confirm'
		});
	};

	return {
		onDismiss
	};
};
